import { ToggleSwitch } from '@/src/components/common/ui/toggleSwitch'
import { useGetRTSolutionCardData } from '@/src/hooks/srp/RTSolutionView/getRTSolutionCardData'
import useUpdateSearchResultCache from '@/src/hooks/srp/updateSearchResultCache'
import useSearchResults from '@/src/hooks/srp/useSearchResults'
import { FlightCard } from '@/src/types/flight'
import { getAirlineIcons } from '@/src/utils/confirmation/airlineUtils'
import { alpha, Box, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'
import { useCallback, useMemo } from 'react'

const SelectedFlightFilter = ({ onwardFlightData }: { onwardFlightData: FlightCard }) => {
    const tCommon = useTranslations('common')
    const flightData = useGetRTSolutionCardData(onwardFlightData)
    const { filterData, selectedJourneyLeg } = useSearchResults()
    const { airlineFilter: airlineFilters } = filterData || {}
    const airlineFilter = airlineFilters?.[selectedJourneyLeg]
    const { selectedValues: selectedAirlines = [] } = airlineFilter || {}
    const updateCache = useUpdateSearchResultCache()
    const isSelectedOnwardFlightAirlinesOnwardFilterApplied = useMemo(() => {
        return (
            selectedAirlines.every(airline => flightData.airlineCodes.includes(airline)) &&
            selectedAirlines.length === flightData.airlineCodes.length
        )
    }, [selectedAirlines, flightData.airlineCodes])

    const handleAirlineFilterChange = useCallback(() => {
        updateCache(currentData => {
            if (currentData?.filterData?.airlineFilter?.[selectedJourneyLeg]) {
                if (isSelectedOnwardFlightAirlinesOnwardFilterApplied) {
                    // currentData.filterData.airlineFilter[selectedJourneyLeg].selectedValues = selectedAirlines.filter(
                    //     airline => !flightData.airlineCodes.includes(airline)
                    // )
                    currentData.filterData.airlineFilter[selectedJourneyLeg].selectedValues = []
                } else {
                    currentData.filterData.airlineFilter[selectedJourneyLeg].selectedValues = flightData.airlineCodes
                }
            }
            return currentData as NonNullable<typeof currentData>
        })
    }, [updateCache, selectedJourneyLeg, isSelectedOnwardFlightAirlinesOnwardFilterApplied, flightData.airlineCodes])

    return (
        <Box
            sx={{
                border: isSelectedOnwardFlightAirlinesOnwardFilterApplied
                    ? theme => `1px solid ${theme.palette.primary.main}`
                    : '1px solid rgb(230, 230, 230)',
                background: isSelectedOnwardFlightAirlinesOnwardFilterApplied
                    ? theme => alpha(theme.palette.primary.light, 0.1)
                    : 'rgb(255, 255, 255)',
                borderRadius: 1,

                mb: 1,
                mx: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                boxShadow: 'none',

            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    width: '100%',
                    // border: '1px solid red',
                    justifyContent: 'space-between',
                    height: '100%',
                    px: 2,
                    py: 1,
                    cursor: 'pointer'
                }}
                onClick={handleAirlineFilterChange}
            >
                <Box display={'flex'} alignItems={'center'}>
                    <Box
                        display={'flex'}
                        maxWidth={150}
                        overflow={'auto'}
                        gap={0.5}
                    // sx={{ filter: isSelectedOnwardFlightAirlinesOnwardFilterApplied ? 'none' : 'grayscale(100%)' }}
                    >
                        {getAirlineIcons(flightData.airlineCodes, 25, 25)}
                    </Box>
                    <Typography sx={{ fontWeight: 600, fontSize: '14px', color: 'text.primary', ml: 0.5 }}>
                        {flightData.airlineCodes?.length > 1
                            ? tCommon('showSelectedAirlinesFlightsOnly')
                            : tCommon('showFlightOnly', { airlineName: flightData.airlineName })}
                    </Typography>
                </Box>

                <ToggleSwitch checked={!!isSelectedOnwardFlightAirlinesOnwardFilterApplied} size="large" />
            </Box>
        </Box>
    )
}

export default SelectedFlightFilter
